import { Callout } from "../components/Callout.js";
import { ScreenshotBox } from "../components/ScreenshotBox.js";

export const meta = {
  title: "固定送付宛先・共有先（CC）",
  updatedAt: "2026-05-22",
};

export function Content() {
  return (
    <>
      <p>
        2 つの「自動で追加される相手」の設定を解説します。
        どちらも「<strong>プロパティ</strong>」タブから設定します。
      </p>

      <h2>固定送付宛先（社内承認者など）</h2>
      <p>
        毎回必ず宛先に含めたい人を登録できます。例: 法務担当者を必ず最後の
        承認者として含める運用に使えます。
      </p>
      <ScreenshotBox src="/guide/screenshots/recipients-1.png" caption="固定送付宛先の設定欄" />

      <h3>登録項目</h3>
      <ul>
        <li><strong>氏名</strong>（必須）: 2 文字以上</li>
        <li><strong>メールアドレス</strong>（必須）</li>
        <li><strong>会社名</strong>（任意）: 送信モーダルで自動反映される</li>
      </ul>

      <Callout type="tip" title="送信モーダルでの動き">
        固定送付宛先は送信モーダルを開いた時点で宛先リストの先頭に並びます。
        順序の入れ替えや、特定の送信時に外すことも可能です。
      </Callout>

      <h3>典型的なユースケース</h3>
      <ul>
        <li>営業 → 顧客 → 法務、の 3 者ワークフローで「法務」を固定</li>
        <li>顧客に送る前に「上長」が必ず先に署名するルール</li>
        <li>すべての書類で代表取締役の押印を最後に挟む</li>
      </ul>

      <h2>共有先（CC 相当）</h2>
      <p>
        署名権限はないが、書類の締結状況を共有したい相手の設定です。
        クラウドサインから締結完了通知メールが届きます。
      </p>
      <ScreenshotBox src="/guide/screenshots/recipients-2.png" caption="共有先（CC）の設定欄" />

      <h3>取得元の選択</h3>
      <ul>
        <li>
          <strong>HubSpot プロパティから取得</strong>: 取引・会社・コンタクトの
          特定プロパティから自動取得（最大 2 名分）
        </li>
        <li>
          <strong>毎回手動入力</strong>: 送信モーダルで都度入力
        </li>
      </ul>

      <h3>送信モーダルでの入力</h3>
      <p>
        モーダルの宛先指定ステップに「共有先」欄があります。氏名（任意）+ メールを
        入力して「追加」を押します。複数登録可能。
      </p>

      <Callout type="warning" title="クラウドサイン側の制限">
        共有先のクラウドサインへの通知はメールアドレスのみを使います。
        当サービスで入力する氏名は、確認画面などの表示用です。
      </Callout>

      <h2>固定送付宛先 vs 共有先 の違い</h2>
      <table style={{ width: "100%", borderCollapse: "collapse", margin: "12px 0" }}>
        <thead>
          <tr style={{ background: "#faf9f7" }}>
            <th style={{ textAlign: "left", padding: "8px 12px", borderBottom: "1px solid #d0cfc9", fontSize: 13 }}></th>
            <th style={{ textAlign: "left", padding: "8px 12px", borderBottom: "1px solid #d0cfc9", fontSize: 13 }}>固定送付宛先</th>
            <th style={{ textAlign: "left", padding: "8px 12px", borderBottom: "1px solid #d0cfc9", fontSize: 13 }}>共有先（CC）</th>
          </tr>
        </thead>
        <tbody style={{ fontSize: 13 }}>
          <tr><td style={td()}>署名権限</td><td style={td()}>あり</td><td style={td()}>なし</td></tr>
          <tr><td style={td()}>毎回自動追加</td><td style={td()}>される</td><td style={td()}>設定次第</td></tr>
          <tr><td style={td()}>順序</td><td style={td()}>署名順に組み込まれる</td><td style={td()}>順序なし</td></tr>
          <tr><td style={td()}>通知</td><td style={td()}>署名依頼メール</td><td style={td()}>締結通知メール</td></tr>
        </tbody>
      </table>
    </>
  );
}

function td() {
  return { padding: "8px 12px", borderBottom: "1px solid #f0efeb" };
}
